import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("process", {
    model: {
      defaults: {
        components: html`
          <section id="process" class="container mx-auto px-4 md:px-16">
            <div class="grid md:grid-cols-2 items-center gap-8 md:mt-10 ">
              <div class="grid grid-cols-1  items-center justify-items-start">
                <div class="flex items-center leading-2.5 gap-1 my-2">
                  <div class="bg-amber-600 w-1 md:h-12 h-6 inline-block"></div>
                  <h3
                    class="md:text-4xl text-lg font-bold font-roboto tracking-normal text-[#0083D7]"
                  >
                    Our Process
                  </h3>
                </div>
                <p class=" md:text-xl text-lg font-roboto tracking-normal ">
                  We ensure seamless cargo handling from booking to delivery,
                  <span class="block leading-7"
                    >providing timely and safe transport across air, land and
                    sea.</span
                  >
                </p>
                <div>
                  <div class="flex items-center gap-1 mt-8 space-x-3">
                    <div
                      class="md:w-[70px] md:h-[70px] size-12 rounded-full shadow-lg flex items-center justify-center font-roboto text-[#FA6914] md:text-[32px] text-2xl mt-[-15px] flex-shrink-0"
                    >
                      1
                    </div>
                    <div class="flex flex-col justify-center">
                      <h3
                        class="text-[#0083D7] font-roboto tracking-normal md:text-2xl font-semibold text-base"
                      >
                        Place Order
                      </h3>
                      <p class=" font-roboto text-gray-400 leading-normal">
                        Easily place your cargo orders online effortlessly
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="flex items-center gap-1 space-x-3 mt-7 md:mt-10 mb-3"
                >
                  <div
                    class="md:w-[70px] md:h-[70px] size-12 rounded-full flex items-center justify-center text-[#FA6914] font-roboto text-2xl md:text-[32px] mt-[-15px] shadow-lg"
                  >
                    2
                  </div>
                  <div class="flex flex-col">
                    <h3
                      class="text-[#0083D7] font-roboto tracking-normal md:text-2xl text-base font-semibold"
                    >
                      Deliver Products
                    </h3>
                    <p class=" leading-normal font-roboto text-gray-400">
                      Deliver your products swiftly and securely
                    </p>
                  </div>
                </div>

                <div
                  class="flex items-center gap-1 space-x-3 mr-3 mt-3 md:mt-8"
                >
                  <div
                    class="md:w-[70px] md:h-[70px] size-12 rounded-full shadow-lg flex items-center justify-center text-[#FA6914] font-roboto md:text-[32px] text-2xl md:mt-[-15px]"
                  >
                    3
                  </div>
                  <div class="flex flex-col">
                    <h3
                      class="text-[#0083D7] font-roboto tracking-normal md:text-2xl font-semibold text-base"
                    >
                      Secure Transportation
                    </h3>
                    <p class="text-gray-400 font-roboto">
                      Secure transportation for your cargo needs
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="flex justify-center md:max-h-120 md:max-w-120 text-align-center"
              >
                <img src="./product.svg" class="w-full h-full p-5" />
              </div>
            </div>
          </section>
        `,
      },
    },
  });
};
